(() => {
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  let busy = false;
  async function request(root, path, payload) {
    const response = await fetch(`${root}${path}`, payload ? { method: 'POST', headers, body: JSON.stringify(payload) } : { headers: { Accept: 'application/json' } });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || response.statusText);
    return data;
  }
  window.DgGiftOffers = {
    async add({ items, discount, root = '/', labels, opener }) {
      if (busy) throw new Error(labels.adding);
      busy = true;
      let added = false;
      try {
        const fullCart = document.getElementById('main-cart-footer');
        const panel = fullCart ? null : document.querySelector('cart-notification, cart-drawer');
        const definitions = panel?.getSectionsToRender() || [];
        const cartItems = fullCart ? document.querySelector('cart-items') : null;
        const cartSections = cartItems?.getSectionsToRender() || [];
        const sections = fullCart ? cartSections.map(section => section.section) : definitions.map(section => section.id);
        const rendering = sections.length ? { sections: [...new Set(sections)].slice(0, 5), sections_url: location.pathname } : {};
        const before = discount ? await request(root, 'cart.js') : null;
        const result = await request(root, 'cart/add.js', { items, ...rendering });
        added = true;
        let state = result;
        if (discount) {
          const codes = (before.discount_codes || []).map(item => item.code);
          const unique = [...new Set([...codes, discount].map(code => code.toUpperCase()))];
          state = await request(root, 'cart/update.js', { discount: unique.join(','), ...rendering });
          if (!state.discount_codes?.some(item => item.code.toUpperCase() === discount.toUpperCase() && item.applicable)) throw new Error(labels.partial);
        }
        if (fullCart) {
          const documents = new Map();
          const replacements = cartSections.map(section => {
            const html = state.sections?.[section.section];
            if (!html) throw new Error(labels.partial);
            if (!documents.has(section.section)) documents.set(section.section, new DOMParser().parseFromString(html, 'text/html'));
            const source = documents.get(section.section).querySelector(section.selector);
            const container = document.getElementById(section.id);
            const target = container?.querySelector(section.selector) || container;
            if (!source || !target) throw new Error(labels.partial);
            return { target, html: source.innerHTML };
          });
          replacements.forEach(({ target, html }) => { target.innerHTML = html; });
          cartItems.classList.remove('is-empty');
          fullCart.classList.remove('is-empty');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
          return state;
        }
        if (panel) {
          const activeItem = state.items?.find(item => Number(item.variant_id || item.id) === Number(items[0].id)) || result.items?.[0] || result;
          panel.setActiveElement(opener);
          panel.classList.remove('is-empty');
          panel.renderContents({ ...state, key: activeItem.key, id: activeItem.id });
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dg-gift-offers' });
        } else location.assign(`${root}cart`);
      } catch (error) {
        error.cartAdded = added;
        if (added) error.message = labels.partial;
        throw error;
      } finally { busy = false; }
    }
  };
  if (customElements.get('dg-gift-addon')) return;
  customElements.define('dg-gift-addon', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.select = this.querySelector('[data-dg-addon-variant]');
      this.button = this.querySelector('[data-dg-addon-add]');
      this.status = this.querySelector('[data-dg-addon-status]');
      this.labels = JSON.parse(this.querySelector('[data-dg-addon-labels]').textContent);
      this.money = value => new Intl.NumberFormat(this.dataset.locale || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(value / 100);
      this.select.addEventListener('change', () => this.update());
      this.button.addEventListener('click', () => this.add());
      this.update();
    }
    update() {
      const option = this.select.selectedOptions[0];
      const price = Number(option.dataset.price);
      this.querySelector('[data-dg-addon-original]').textContent = this.money(price);
      this.querySelector('[data-dg-addon-price]').textContent = this.money(price - Math.floor(price * Number(this.dataset.percent) / 100));
      const image = this.querySelector('img');
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
      this.button.disabled = option.disabled;
    }
    async add() {
      if (this.button.disabled || this.added) return;
      const oldLabel = this.button.textContent;
      const landing = this.dataset.context === 'product' ? this.closest('dg-product-landing') : null;
      if (landing && (!landing.form.reportValidity() || !landing.variant?.available)) return;
      const items = [];
      if (landing) {
        const data = new FormData(landing.form);
        const properties = {};
        data.forEach((value, key) => { const match = key.match(/^properties\[(.+)\]$/); if (match && typeof value === 'string') properties[match[1]] = value; });
        items.push({ id: landing.variant.id, quantity: Number(landing.quantity.value) || 1, properties });
      }
      items.push({ id: Number(this.select.value), quantity: 1 });
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.button.textContent = this.labels.adding;
      this.status.hidden = true;
      try {
        await window.DgGiftOffers.add({ items, discount: this.dataset.code, root: this.dataset.root, labels: this.labels, opener: this.button });
        this.added = true;
        this.button.textContent = this.labels.added;
      } catch (error) {
        this.status.textContent = error.message || this.labels.error;
        this.status.hidden = false;
        if (error.cartAdded) {
          this.added = true;
          this.button.textContent = this.labels.added;
          const link = document.createElement('a');
          link.href = `${this.dataset.root}cart`;
          link.textContent = this.labels.added;
          this.status.append(' ', link);
        } else { this.button.disabled = false; this.button.textContent = oldLabel; }
      } finally { this.button.removeAttribute('aria-busy'); }
    }
  });
})();

